import { ChangeEvent } from 'react'
import styles from '../styles.module.css'
import { MenuItem, TextField } from '@mui/material'
import { IUserPartial } from '../../../../app/entities/User'
import { isValidEmail } from '../../global/utils/formValidation'
import PrimaryCheckbox from '../../global/components/checkbox/Checkbox'

interface IUserCreateProps {
  userData: IUserPartial
  setUserData: Function
  formError: boolean
  setFormError: Function
}

export default function UserCreate(props: IUserCreateProps) {
  const { userData, setUserData, formError, setFormError } = props
  const { name, email, role, careTeam } = userData
  const handleChangeForm = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value, checked } = e.target
    if (name === 'email' && !isValidEmail(value)) {
      setFormError(true)
    } else {
      setFormError(false)
    }
    setUserData({ ...userData, [name]: name === 'careTeam' ? checked : value })
  }

  return (
    <div className={styles.formContainer}>
      <TextField
        value={name}
        onChange={handleChangeForm}
        label='Name'
        name='name'
        fullWidth
      />
      <TextField
        value={email}
        onChange={handleChangeForm}
        label='Email'
        name='email'
        error={formError}
        helperText={formError && 'Please enter a valid email address'}
        fullWidth
      />
      <RoleDropDown
        value={role}
        onChange={handleChangeForm}
      />
      <PrimaryCheckbox
        checked={userData.careTeam ?? false}
        name='careTeam'
        onChange={handleChangeForm}
        label='Care team?'
      />
    </div>
  )
}
const roles = [
  'Technician',
  'Admin',
  'CS User',
  'CS Manager',
  'Report Viewer',
  'Warehouse',
  'Tech Manager',
]
const RoleDropDown = ({ value, onChange }: any) => {
  const menuItems = roles.map((role, idx) => {
    return (
      <MenuItem
        key={idx}
        value={role}
      >
        {role}
      </MenuItem>
    )
  })
  return (
    <TextField
      label='Role'
      select
      name='role'
      fullWidth
      value={value}
      onChange={onChange}
    >
      {menuItems}
    </TextField>
  )
}
